import { UserLocation } from '@redux/user/types';

export const getUserRegion = (locations: UserLocation[] | null) =>
  locations?.find((location) => !!location?.code)?.code;
